export default __webpack_public_path__ + "static/media/nestjs.d9caa376.png";